import { routes } from "routing";
import { lazyView, type RouteRender } from "routing/tree";

export const createItineraryRoutes: RouteRender[] = [
  lazyView(
    routes.createItinerary,
    () => import("./create-itinerary").then((m) => ({ default: m.CreateItineraryPage })),
    "New Itinerary",
  ),
];
